export class ComponentInfo {
    constructor(public readonly description: string,
                public readonly direction: string,
                public readonly link: string,
                public readonly moduleVer: string,
                public color: string,
                public ico: string,
                public useClientName: boolean
    ) {

    }

}



// WEBPACK FOOTER //
// ./src/app/shared/models/component-info.ts